import styled from 'styled-components';
import { Button, Input, Checkbox, Select } from 'antd';

interface ButtonViewProps {
    outline?: boolean;
}

export const ButtonView = styled(Button)<ButtonViewProps>`
    height: 40px;
    background: #8a786a;
    border-radius: 20px;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: #ffffff;
    padding-left: 24px;
    padding-right: 24px;
    margin: 0 12px;
    ${(props) =>
        props.outline
            ? `
    border: 1px solid #8A786A;
    background-color: #fff;
    color: #8A786A;
  `
            : ``}
`;
export const InputView = styled(Input)`
    height: 40px;
    border: 1px solid #dddddd;
    border-radius: 10px;
    width: 100%;
`;
export const InputPasswordView = styled(Input.Password)`
    height: 40px;
    border: 1px solid #dddddd;
    border-radius: 10px;
    width: 100%;
`;
export const CheckboxView = styled(Checkbox)`
    display: flex;
    align-items: center;

    & .ant-checkbox-inner {
        width: 20px;
        height: 20px;
        border: 1px solid #cccccc;
        border-radius: 3px;
    }

    & .ant-checkbox-inner::after {
        left: 5px;
    }

    & .ant-checkbox-checked .ant-checkbox-inner {
        background-color: #006561;
        border-color: #006561;
    }

    & .ant-checkbox + span {
        font-weight: 400;
        font-size: 14px;
        color: #1c1c1c;
        display: flex;
        line-height: 20px;
        padding-top: 6px;
        height: 24px;
    }
`;
export const LinkView = styled.a``;

export const SelectView = styled(Select)`
    & .ant-select-selector {
        height: 40px !important;
        border: 1px solid #dddddd !important;
        border-radius: 10px !important;
        width: 100%;
    }

    & .ant-select-selection-item {
        line-height: 40px !important;
    }
`;
